export class PathName {
    static TOKEN = 'TOKEN_RH';
    static USER_NAME = 'USER_NAME';
    static ROLES = 'ROLES';
    static USER_CURRENT = 'USER_CURRENT';
}

